export default "__VITE_ASSET__DujhvRqv__"